<template>
    <div
    id="viewPort"
    ref="viewPort"
    class="viewPort use-pointer"
    :style="{
      top: top + 'px',
      left: left + 'px',
      width: documentAreaWidth + 'px',
      height: documentAreaHeight + 'px'
    }"
    @click="clickAction"
    @dragstart="dragAction"
    @mousedown="pstart"
    @mousemove="pmove"
    @mouseup="pend"
    @touchstart="tstart"
    @touchmove="tmove"
    @touchcancel="tcancel"
    @touchend="tend"
  >
    <transition :name="slideDir" @after-leave="afterLeaveAction">
       <img
        v-if="dispOne"
        key="page1"
        id="page1"
        ref="page1"
        class="bookpageImage no-pointer"
        :src="viewImage1"
        :style="{
          top: '0px',
          left: '0px',
          width: '100vw',
          height: '100%'
        }"
      />
      <img
        v-if="!dispOne"
        key="page2"
        id="page2"
        ref="page2"
        class="bookpageImage no-pointer"
        :src="viewImage2"
        :style="{
          top: '0px',
          left: '0px',
          width: '100vw',
          height: '100%'
        }"
      />
    </transition>
    <img
      v-show="moving || moveAnimating"
      key="page0"
      id="page0"
      ref="page0"
      class="bookpageImage no-pointer"
      :src="viewImage0"
      :style="{
        top: '0px',
        left: '100vw',
        width:'100vw',
        height: '100%'
       }"
    />
        <div v-if="loading">
            <div v-if="loading" class="loader wf-mincho"></div>
            <div class="loader_message"><pre style="font-size: 0.9rem; font-family: 'Noto Serif JP', serif;">{{loadingMessage}}</pre></div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
let debugOut = false
const dispBorder = true
const dispLimit = false
let layoutConst = null
let LineStyle = null
let WordType = null
let WordTypeMask = null
let PropFlag = null
let PictureFlags = null
let NombreMode = null
let SpecialLineIndex = null
let gaijiArea = null
export default {
  name: "BookpageView",
  components: {

  },
  props: {
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: null
    },
    nowIndex: {
      type: [Number, Object],
      default: 0
    },
    uivis: {
      type: Boolean,
      required: false
    },
    browsevis: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    loadingMessage: {
      type: String,
      default: 'Waiting...',
    },
  },
  data() {
    return {
      // viewWidth: 0,
      // viewHeight: 0,
      writeOne: true,
      dispOne: true,
      slideDir: "slideleft",
      imageFitClass: "imageFitNone",
      pageImage0: {},
      pageImage1: {},
      pageImage2: {},
      pageImageIndex:[-1,-1,-1],
      toLeft:false,
      moving: false,
      moveAnimating: false,
      moveStartTime:0,
      moveStartX: -1000,
      moveStartY: -1000,
      moveTID:-1000,
      mbtndown:false,
      moveEl: null,
      page0El: null,

      nowPageIndex: 0,

      offcvs: null,

      gaijiList: null,
    };
  },
  async created() {
    debugOut = this.$root.$options.debugOut
    if (debugOut) {console.log(`w:${this.width} daw:${this.documentAreaWidth} h:${this.height} dah:${this.documentAreaHeight}`)}
    // if (this.width == null) this.viewWidth = this.documentAreaWidth;
    // if (this.height == null) this.viewHeight = this.documentAreaHeight;
    // this.nowLoadingImg = new Image()
    // this.missingFileImg = new Image()
    let svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>NowLoading</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.25">
        <g id="NowLoading" fill="#CDEDFF">
            <path d="M54,11 L54,89.0440021 L62.3125,89.0440021 L62.3125,44.1943426 L73.6875,89.0440021 L82.1875,89.0440021 L82.1875,11 L73.875,11 L73.875,54.6375065 L63.3125,11 L54,11 Z M86,42.8931378 C86.0416669,33.6309996 88.895805,29 94.5625,29 L105.9375,29 C111.645862,29 114.5,33.5999191 114.5,42.7998952 L114.5,75.5280251 C114.458333,84.7901633 111.1042,89.4211629 104.4375,89.4211629 L95.5625,89.4211629 C89.1874681,89.4211629 86,84.8523244 86,75.7145102 L86,42.8931378 Z M94,47.0864327 L94,69.3713986 C94.0416669,75.1524647 95.39582,78.0429544 98.0625,78.0429544 L101.1875,78.0429544 C103.812513,78.0429544 105.125,75.2146258 105.125,69.5578837 L105.125,47.5526454 C105.083333,42.5175233 103.979177,40 101.8125,40 L97.8125,40 C95.2708206,40 94,42.3621206 94,47.0864327 Z M116,29 L121.4375,89.4211629 L128,89.4211629 L131.375,52.9633316 L135.125,89.4211629 L141.6875,89.4211629 L146.625,29 L139.3125,29 L137.625,57.9984285 L134.6875,29 L127.9375,29 L125.1875,57.905186 L123.3125,29 L116,29 Z M11.6875,173.2022 L11.6875,107 L3,107 L3,185.044002 L29.875,185.044002 L29.875,173.2022 L11.6875,173.2022 Z M33,137.893138 C33.0416669,128.631 35.895805,124 41.5625,124 L52.9375,124 C58.6458619,124 61.5,128.599919 61.5,137.799895 L61.5,170.528025 C61.4583331,179.790163 58.1042,184.421163 51.4375,184.421163 L42.5625,184.421163 C36.1874681,184.421163 33,179.852324 33,170.71451 L33,137.893138 Z M41,143.086433 L41,165.371399 C41.0416669,171.152465 42.39582,174.042954 45.0625,174.042954 L48.1875,174.042954 C50.8125131,174.042954 52.125,171.214626 52.125,165.557884 L52.125,143.552645 C52.0833331,138.517523 50.9791775,136 48.8125,136 L44.8125,136 C42.2708206,136 41,138.362121 41,143.086433 Z M91.5,184.421163 L84,184.421163 L84,180.691461 C81.9583231,183.177942 79.6875125,184.421163 77.1875,184.421163 L73.5,184.421163 C67.833305,184.421163 65,179.665841 65,170.155055 L65,159.059193 C65,150.356513 67.99997,146.005238 74,146.005238 L84,146.005238 L84,139.105291 C83.9583331,135.686381 82.9166769,133.976951 80.875,133.976951 L77.3125,133.976951 C75.0624887,133.976951 73.9375,135.686381 73.9375,139.105291 L73.9375,143.674175 L66,143.674175 L66,136.214772 C66,128.07155 69.0208031,124 75.0625,124 L82.75,124 C88.5833625,124.062162 91.5,128.133712 91.5,136.214772 L91.5,184.421163 Z M83.3125,155 L74.5625,155 C72.8541581,155 72,156.77159 72,160.314825 L72,169.079623 C72.0416669,172.622857 73.0833231,174.394447 75.125,174.394447 L76.5,174.394447 C79.0000125,174.332285 80.8958269,172.218809 82.1875,168.053955 C82.9375037,165.567475 83.3125,163.018871 83.3125,160.408067 L83.3125,155 Z M96,135.252488 C96.0416669,128.16602 98.2708112,124.622839 102.6875,124.622839 L107.1875,124.622839 C108.812508,124.622839 110.437492,125.928222 112.0625,128.539026 L112.0625,107 L120.75,107 L120.75,185.044002 L112.0625,185.044002 L112.0625,181.034573 C110.437492,183.707539 108.812508,185.044002 107.1875,185.044002 L102.6875,185.044002 C98.2291444,184.98184 96,181.283257 96,173.94814 L96,135.252488 Z M105,170.22001 C105.041667,172.768653 105.770826,174.042954 107.1875,174.042954 L110.125,174.042954 C111.625007,173.980792 112.375,172.333524 112.375,169.1011 L112.375,147.095862 C112.375,139.698584 111.625007,136 110.125,136 L107.1875,136 C105.729159,136.062162 105,137.522947 105,140.382399 L105,170.22001 Z M125,107 L125,121.918806 L133.6875,121.918806 L133.6875,107 L125,107 Z M125,127 L125,184.903614 L133.6875,184.903614 L133.6875,127 L125,127 Z M139,124 L139,184.421163 L147.6875,184.421163 L147.6875,139.105291 C147.937501,136.618811 148.791659,135.375589 150.25,135.375589 L153.6875,135.375589 C155.437509,135.375589 156.3125,137.116099 156.3125,140.597171 L156.3125,184.421163 L165,184.421163 L165,135.095862 C165,127.760746 162.750023,124.062162 158.25,124 L153.125,124 C151.458325,124 149.645843,125.647268 147.6875,128.941854 L147.6875,124 L139,124 Z M186.9375,189.015715 L178.75,189.015715 C172.249968,189.015715 169,185.534695 169,178.572551 L169,169.900995 C169.041667,165.736141 169.833326,162.628088 171.375,160.576742 C170.666663,159.457826 170.3125,158.338926 170.3125,157.22001 C170.354167,155.230826 171.395823,153.365994 173.4375,151.625458 C171.729158,149.82276 170.875,146.932271 170.875,142.953903 L170.875,133.256679 C170.875,127.164803 173.395808,124.11891 178.4375,124.11891 L186.25,124.11891 C189.041681,124.11891 191.083327,124.989165 192.375,126.729701 C193.750007,124.243221 195.458323,123 197.5,123 L197.5,133.070194 C196.458328,133.070194 195.729169,133.753966 195.3125,135.12153 C194.895831,136.178284 194.562501,138.385002 194.3125,141.74175 L194.3125,145.844421 C194.3125,151.190353 191.479195,153.863279 185.8125,153.863279 L180.1875,153.863279 C179.395829,153.863279 179,154.422729 179,155.541645 C179.041667,156.598399 179.270831,157.25109 179.6875,157.499738 L187.9375,157.499738 C193.854196,157.499738 196.8125,161.167241 196.8125,168.502357 L196.8125,178.852279 C196.770833,185.627937 193.479199,189.015715 186.9375,189.015715 Z M178,143.443164 C178,145.49451 179.062489,146.520168 181.1875,146.520168 L183.75,146.520168 C185.875011,146.520168 186.9375,145.49451 186.9375,143.443164 L186.9375,135.610791 C186.895833,133.870255 185.979176,133 184.1875,133 L181,133 C178.99999,133 178,133.839174 178,135.517548 L178,143.443164 Z M177,178.375589 C177,180.551259 178.249988,181.639078 180.75,181.639078 L183.6875,181.639078 C186.187512,181.576916 187.4375,180.489097 187.4375,178.375589 L187.4375,169.890519 C187.4375,167.963497 186.375011,167 184.25,167 L180.5,167 C178.166655,167 177,167.932416 177,169.797276 L177,178.375589 Z" id="Now-Loading"></path>
        </g>
    </g>
</svg>`
    // this.nowLoadingImg.src = "data:image/svg+xml;charset=utf-8;base64," + btoa(svg)
    this.nowLoadingImg = await this.makeSVGImage(svg)
    svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>MissingFile</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="MissingFile">
            <g id="Group">
                <path d="M88.7288127,5.10702591e-15 L7.99587851,5.10702591e-15 C3.57531048,5.10702591e-15 0,3.57932539 0,7.99464702 L0,192.005353 C0,196.422372 3.57987675,200 7.99587851,200 L84.0697804,200 L77.8345066,193.231523 L98.0629877,177.003607 L77.7541893,153.111128 L100.422786,135.563715 L76.8859977,124.093642 L97.5428376,103.008443 L78.9971949,86.6428409 L99.2027281,66.5099756 L79.8347894,50.178795 L97.2483409,28.0991918 L78.5879592,11.2096149 L88.7288127,0 L88.7288127,5.10702591e-15 Z" id="Combined-Shape" fill="#EFFFDF"></path>
                <path d="M88.7288127,5.10702591e-15 L7.99587851,5.10702591e-15 C3.57531048,5.10702591e-15 0,3.57932539 0,7.99464702 L0,192.005353 C0,196.422372 3.57987675,200 7.99587851,200 L84.0697804,200 L80.3848901,196 L7.998442,196 C5.79016346,196 4,194.206819 4,192.000846 L4,7.99915357 C4,5.79048204 5.786708,4 7.998442,4 L85.1101858,4 L88.7288127,0 L88.7288127,5.10702591e-15 Z" id="Combined-Shape" fill="#9B9B9B"></path>
                <polygon id="Combined-Shape" fill="#F8E81C" points="95.0400779 63 30 63 30 140 94.6917782 140 100.422786 135.563715 76.8859977 124.093642 97.5428376 103.008443 78.9971949 86.6428409 99.2027281 66.5099756 95.0400779 63"></polygon>
                <path d="M87.1010144,40.9655472 C79.5644675,34.7558915 69.7422474,31 59,31 C35.2517558,31 16,49.3563253 16,72 C16,94.6436747 35.2517558,113 59,113 C72.3038151,113 84.1965138,107.239302 92.084029,98.1913176 L78.9971949,86.6428409 L99.2027281,66.5099756 L79.8347894,50.178795 L87.1010144,40.9655472 L87.1010144,40.9655472 Z" id="Combined-Shape" fill="#0088FF"></path>
                <path d="M95.574437,179 L72,179 L83.8479674,160.280212 L98.0629877,177.003607 L95.574437,179 Z M98.5966432,136.977304 L99.7108919,135.216791 L100.422786,135.563715 L98.5966432,136.977304 Z" id="Combined-Shape" fill="#FF0000"></path>
            </g>
            <g id="Group-2" transform="translate(96.000000, 0.000000)">
                <path d="M12.7288127,0 L96.0041215,0 C100.420123,0 104,3.57762838 104,7.99464702 L104,192.005353 C104,196.420675 100.42469,200 96.0041215,200 L8.06978037,200 L1.83450658,193.231523 L22.0629877,177.003607 L1.7541893,153.111128 L24.4227859,135.563715 L0.885997734,124.093642 L21.5428376,103.008443 L2.99719485,86.6428409 L23.2027281,66.5099756 L3.83478936,50.178795 L21.2483409,28.0991918 L2.58795918,11.2096149 L12.7288127,6.66133815e-16 L12.7288127,0 Z" id="Combined-Shape" fill="#EFFFDF"></path>
                <path d="M12.7288127,0 L96.0041215,0 C100.420123,0 104,3.57762838 104,7.99464702 L104,192.005353 C104,196.420675 100.42469,200 96.0041215,200 L8.06978037,200 L4.38489014,196 L96.001558,196 C98.213292,196 100,194.209518 100,192.000846 L100,7.99915357 C100,5.79318122 98.2098365,4 96.001558,4 L9.11018577,4 L12.7288127,6.66133815e-16 L12.7288127,0 Z" id="Combined-Shape" fill="#9B9B9B"></path>
                <polygon id="Combined-Shape" fill="#F8E81C" points="19.0400779 63 75 63 75 140 18.6917782 140 24.4227859 135.563715 0.885997734 124.093642 21.5428376 103.008443 2.99719485 86.6428409 23.2027281 66.5099756"></polygon>
                <path d="M11.1010144,40.9655472 C20.2257629,48.4837842 26,59.5989333 26,72 C26,81.9586417 22.2762824,91.0880147 16.084029,98.1913176 L2.99719485,86.6428409 L23.2027281,66.5099756 L3.83478936,50.178795 L11.1010144,40.9655472 L11.1010144,40.9655472 Z" id="Combined-Shape" fill="#0088FF"></path>
                <polygon id="Combined-Shape" fill="#FF0000" points="19.574437 179 96 179 46 100 23.7108919 135.216791 24.4227859 135.563715 22.5966432 136.977304 7.84796737 160.280212 22.0629877 177.003607"></polygon>
            </g>
        </g>
    </g>
</svg>`
    // this.missingFileImg.src = "data:image/svg+xml;charset=utf-8;base64," + btoa(svg)
    this.missingFileImg = await this.makeSVGImage(svg)
  },
  watch: {
    // newIndex: function(nv, ov) {
    // },
    loading: function(nv, ov) {
      if (debugOut) {console.log(`loading ${nv} (old: ${ov})`)}
      if (nv) return
      this.forceUpdate(this.indexToPage(this.nowIndex))
    },
  },
  mounted() {
    // let pages = [{},{}];
    // let vp = document.getElementById('viewPort');
    // for (var i=0;i<2;i++) {
    //   let img = document.createElement('img');
    //   img.key = `page${i + 1}`;
    //   img.id = `page${i + 1}`;
    //   img.alt = 'Page Image';
    //   img.src = require("../assets/blank_dummy.png");
    //   img.className = 'bookpageImage no-pointer';
    //   img.style.left = '0vw';
    //   img.style.top = '0vh';
    //   img.style.width = '100vw';
    //   img.style.height = '100vh';
    //   img.style.opacity = (1 - i);
    //   pages[i] = img;
    //   vp.appendChild(img);
    // }
    // this.page1 = pages[0];
    // this.page2 = pages[1];

    // this.page1 = document.getElementById("page1");
    // this.page2 = document.getElementById("page2");
    this.pageImage0 = require("../assets/blank_dummy.png");
    this.pageImage1 = require("../assets/blank_dummy.png");
    this.pageImage2 = require("../assets/blank_dummy.png");
    if (debugOut) {console.log("mounted  !");}

    // let el = document.getElementById(this.dispOne ? 'page1' : 'page2');
    // this.addGestureListeners(el);
    this.supportTouch = 'ontouchend' in document;
    this.moving = false;
    this.page0El = document.getElementById('page0');

  },
  beforeDestroy() {
    // let el = document.getElementById(this.dispOne ? 'page1' : 'page2');
    // this.removeGestureListeners(el);
   },
  computed: {
    bufWidth() {
      return this.unitMulti(this.documentAreaWidth, window.devicePixelRatio)
    },
    bufHeight() {
      return this.unitMulti(this.documentAreaHeight, window.devicePixelRatio)
    },
    // newIndex() {
    //   return isNaN(this.index) ? -1 : this.index;
    // },
    viewScale() {
      return 1 / window.devicePixelRatio
    },
    viewImage0() {
      return this.toLeft == this.pageFeedRight ? this.pageImage2 : this.pageImage0
    },
    viewImage1() {
      return this.writeOne ? this.pageImage1 : this.pageImage2
    },
    viewImage2() {
      return this.writeOne ? this.pageImage2 : this.pageImage1
    },
    papiDir() {
      return this.$root.$options.commandPath
    },
    baseDir() {
      return this.$root.$options.serverPath
    },
    dataURL() {
      return this.baseDir + this.$root.$options.dataDir
    },
    picsPath() {
      return '../' + this.$root.$options.dataDir + (this.resourcePath ? '/' + this.resourcePath : "")
    },
    publishedDir() {
      return this.dataURL + (this.resourcePath ? '/' + this.resourcePath : "")
    },
    workTimestamp() {
      return this.$store.state.workTimestamp
    },
    resourcePath() {
      return this.$store.state.resourcePath
    },
    ...mapState([
        'documentAreaWidth',
        'documentAreaHeight',
    ]),
  },
  methods: {
    pageFlip: function(dir) {
      if (debugOut) {console.log("page flip!");}
      if (dir === undefined) dir = 'right'
      this.pageNew(dir);
    },
    pageNew(dir) {
      let newPage = this.nowPageIndex + ((dir === 'left') === this.pageFeedRight ? -1 : 1)
      if (newPage < 0 || newPage >= this.numOfPages) {
        if (debugOut) {console.log(`pageFeedRight:${this.pageFeedRight}`)}
        window.getSelection().removeAllRanges()
        return
      }
      this.writeOne = !this.writeOne
      this.nowPageIndex = newPage
      // if (debugOut) {console.log(`pageNew [${this.nowPageIndex}]`)}
      this.allPageSetup(newPage)
      if (this.dispOne != this.writeOne) this.flip(dir)
    },
    forceUpdate(pageIndex) {
      this.pageImageIndex = [-1,-1,-1]
      this.pageUpdate(pageIndex)
    },
    handleResize() {
      this.forceUpdate(this.indexToPage(this.nowIndex))
    },
    pageUpdate(newPageIndex) {
      if (newPageIndex != undefined) {
        this.nowPageIndex = newPageIndex
      }
      if (debugOut) {console.log(`pageUpdate! [${this.nowPageIndex}]`)}
      this.writeOne = this.dispOne
      this.allPageSetup(this.nowPageIndex)
    },
    allPageSetup(visPageIndex) {
      let page = [(visPageIndex <= 0 ? -1 : visPageIndex - 1),visPageIndex,((visPageIndex + 1) >= this.numOfPages ? -1 : visPageIndex + 1)]
      let image = [this.pageImage0,this.pageImage1,this.pageImage2]
      let newImage = [null,null,null]

      page.forEach((vi, i) => {
        if (vi === -1) return
        let s = this.pageImageIndex.indexOf(vi)
        if (s === -1) return
        newImage[i] = image[s]
      })

      this.pageImageIndex = page
      const pagesDraw = async () => {
        this.pageImage0 = (page[0] === -1) ? null : ((newImage[0] !== null) ? newImage[0] : await this.drawPage(page[0]))
        this.pageImage1 = (page[1] === -1) ? null : ((newImage[1] !== null) ? newImage[1] : await this.drawPage(page[1]))
        this.pageImage2 = (page[2] === -1) ? null : ((newImage[2] !== null) ? newImage[2] : await this.drawPage(page[2]))
      }
      pagesDraw()
      this.$emit('pagesUpdate',visPageIndex)
    },
    setLayoutConst(c,ls,wt,wtm,pf,picf,nm,sli,ga) {
      layoutConst = c
      LineStyle = ls
      WordType = wt
      WordTypeMask = wtm
      PropFlag = pf
      PictureFlags = picf
      NombreMode = nm
      SpecialLineIndex = sli
      gaijiArea = ga
    },
    setLayoutParams(params,pageData,layoutData,gaijis) {
      if (debugOut) {console.log('setLayoutParams --- params:' + JSON.stringify(params))}
      this.pageStart = params.pageStart
      this.numOfPages = params.numOfPages
      this.vertically = params.vertically
      this.pageFeedRight = params.pageFeedRight
      this.numColumn = params.numColumn
      this.authorName = params.authorName.replace(/\\n/g,'\n')       //改行のエスケープシーケンスのみ変換対応
      this.contentsTitle = params.contentsTitle.replace(/\\n/g,'\n')       //改行のエスケープシーケンスのみ変換対応
      this.numLine = params.numLine
      this.wpages = params.wpages
      this.letterFont = params.letterFont
      this.letterVFont = `${params.letterVFont}`
      this.picCapFont = params.picCapFont
      this.letterSize = params.letterSize
      this.bottomCorrection = params.bottomCorrection
      this.graphRatio = params.graphRatio
      this.gapSize = params.gapSize
      this.lineHeight = params.lineHeight
      this.docWidth = params.docWidth
      this.docHeight = params.docHeight
      this.linesWidth = params.linesWidth
      this.columnsWidth = params.columnsWidth
      this.contentsMargin = params.contentsMargin
      this.wpContWidth = params.wpContentsWidth
      this.rubySize = Math.floor(this.letterSize * layoutConst.rubyRatio)
      this.contentsRatio = 1 - (this.contentsMargin * 2)
      this.appAspect = params.appAreaAspect
      this.offcvs = params.offcvs
      this.pageData = pageData
      this.layoutData = layoutData
      this.pictures = {}
      this.picbuflist = []
      this.rubyFontStyle = `${this.rubySize}px ${this.letterFont}`
      this.gaijiList = gaijis
    },
    picbufDispose() {
      let count = this.picbuflist.length
      if (count < 5) return
      count -= 5
      for (let i = 0;i < count;i += 1) {
        let num = this.picbuflist.shift()
        delete this.pictures[num]
      }
    },
    picbufPush(num) {
      if (num === 'cover') return
      let index = this.picbuflist.indexOf(num)
      if (index !== -1) this.picbuflist.splice(index,1)
      this.picbuflist.push(num)
    },
    loadImage(num,pageIndex,picCover) {
      let now = performance.now()
      if (picCover) num = "cover"
      if (this.pictures[num] !== undefined) {
        if ((this.pictures[num].status !== -1) || ((now - this.pictures[num].ts) < 5000 )) { //前回が読み込み失敗以外か、読み込み失敗から5秒以内の場合は現状の情報を返す
          this.picbufPush(num)
          return this.pictures[num]
        }
      }
      this.pictures[num] = {
        ts: now,
        img: this.nowLoadingImg,
        status: 0,
        last: now,
      }
      let image = new Image()
      image.addEventListener("load", () => {
        // if (debugOut) {console.log(`loaded:${name}`)}
        if (this.pictures[num].ts > now) return          //本処理よりも後に読み込み指示が出されていた
        let img = new Image()
        let cv = document.createElement('canvas')
        cv.width = image.naturalWidth
        cv.height = image.naturalHeight
        let ct = cv.getContext('2d')
        ct.drawImage(image, 0, 0)
        img.addEventListener("load", () => {
          this.pictures[num].img = img
          // if (num === "cover") {
          //   this.pictures[num].status = -1
          // } else {
            this.pictures[num].status = 1
          // }
          this.pageImageReplace(pageIndex)
        },true)
        img.src = cv.toDataURL("image/jpeg", 0.7)
      }, false)
      image.onerror = () => {
        if (this.pictures[num].ts > now) return          //本処理よりも後に読み込み指示が出されていた
        // if (debugOut) {console.log(`load error:${name}`)}
        this.pictures[num].img = this.missingFileImg
        this.pictures[num].status = -1
        this.pageImageReplace(pageIndex)
      }
      this.loadJpeg(this.picsPath + '/pics/' + `${num}.jpg`,r => {
        image.src = r
      })
      // image.src = this.publishedDir + '/pics/' + `${num}.jpg` // require(`@/assets/testdata/${num}.jpg`)
      this.picbufPush(num)
      return this.pictures[num]
    },
    loadJpeg(path,onLoad,onError) {
      if (debugOut) {console.log(`loadJpeg : '${path}'`)}
      let xhr = new XMLHttpRequest()
      xhr.onload = (e) => {
        if ((xhr.readyState === 4) && (xhr.status === 200) && xhr.responseText.startsWith('data:image/jpeg;base64,')) {
          if (onLoad) {
            onLoad(xhr.responseText)
          }
        } else {
          if (debugOut) {console.log('load jpeg error : ' + xhr.responseText)}
          if (onError) {
            onError(e)
          }
        }
      }
      if (onError) {
        xhr.onerror = onError
        xhr.onabort = onError
        xhr.ontimeout = onError
      }

      xhr.open('POST', this.$root.$options.commandPath + '/jpegsrc.php', true)
      // xhr.withCredentials = true
      // xhr.responseType = 'text'
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      xhr.setRequestHeader('Pragma', 'no-cache')
      xhr.setRequestHeader('Cache-Control', 'no-cache')
      // xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00')
      xhr.send(`path=${encodeURIComponent(path)}`)
    },
    async pageImageReplace(pageIndex) {
      if (debugOut) {console.log(`replace page ${pageIndex}`)}
      if (this.pageImageIndex[0] === pageIndex) {
        this.pageImage0 = await this.drawPage(pageIndex)
        return
      }
      if (this.pageImageIndex[1] === pageIndex) {
        this.pageImage1 = await this.drawPage(pageIndex)
        return
      }
      if (this.pageImageIndex[2] === pageIndex) this.pageImage2 = await this.drawPage(pageIndex)
    },
    indexToPage(i) {
      if (this.loading) return undefined
      let pageIndex = this.pageData.findIndex(value => {
        return ((value.start <= i) && (i < (value.start + value.length)))
      })
      return (pageIndex < 0) ? undefined : pageIndex
    },
    async drawPage(page) {
      if (debugOut) {console.log(`drawPage ${page}`)}
      let letterRatio = this.letterSize / layoutConst.tentativeSize
      let baseLineWidth = Math.floor(this.letterSize / 12 * 10) / 10
      if (baseLineWidth < 1) baseLineWidth = 1
      let ctx = this.offcvs.getContext("2d")
      let left = this.docWidth * this.contentsMargin
      let right = this.docWidth - left
      let top = this.docHeight * this.contentsMargin
      let bottom = this.docHeight - top
      let nowContentsRatio = this.contentsRatio
      ctx.clearRect(0, 0, this.documentAreaWidth + 1, this.documentAreaHeight)
      if (debugOut) {console.log(`clear rect: canvas ${this.offcvs.width} x ${this.offcvs.height}  doc ${this.documentAreaWidth} x ${this.documentAreaHeight}`)}
      ctx.save()
      if (dispBorder) {
        ctx.strokeStyle = "#cafcff"
        ctx.strokeRect(0, 0, this.documentAreaWidth - 1, this.documentAreaHeight - 1)
      }
      if (dispLimit) {
        const drawLine = (context,x1,y1,x2,y2) => {
          context.beginPath()
          context.moveTo(x1, y1)
          context.lineTo(x2, y2)
          context.closePath()
          context.stroke()
        }
        let tentaWidthLimit = ((layoutConst.charSpacing * layoutConst.tentativeSize * (this.numColumn - 1)) + layoutConst.tentativeSize) * letterRatio
        let tmpWidth = (right - left), tmpHeight = (bottom - top), hOffset, vOffset, startH = left, startV = top, endH = right, endV = bottom
        if (this.vertically) {
          startV = top + tentaWidthLimit
          endV = startV
          hOffset = 0
          vOffset = this.docHeight
        } else {
          startH = left + tentaWidthLimit
          endH = startH
          hOffset = this.docWidth
          vOffset = 0
        }
        ctx.strokeStyle = "#abd1ff"
        ctx.setLineDash([2, 2])
        ctx.strokeRect(left, top, tmpWidth, tmpHeight)
        if (this.wpages) {
          ctx.strokeRect(left + hOffset, top + vOffset, tmpWidth, tmpHeight)
        }
        ctx.setLineDash([1, 4])
        drawLine(ctx, startH, startV, endH, endV)
        if (this.wpages) {
          drawLine(ctx, (startH + hOffset), (startV + vOffset), (endH + hOffset), (endV + vOffset))
        }
      }
      const gaijiCheck = (u) => {
        // let tmpCp = u.codePointAt()
        // for (let i = 0; i < 6; i += 2) {
        //   if (tmpCp < gaijiArea[i]) return null
        //   if (tmpCp <= gaijiArea[i + 1]) {
        //     let g = this.gaijiList[u]
        //     return g || null
        //   }
        // }
        // return null
        return this.gaijiList[u] || null
      }
      const drawGaiji = (u, ctx, x, y, size, w) => {
        let g = gaijiCheck(u)
        if (g) {
          // ctx.save()
          ctx.drawImage(g.glyph, x, y-size, size, size)
          // ctx.restore()
        } else {
          if (u !== layoutConst.tagControlStr) {
            if (w === undefined) {
              ctx.fillText(u, x, y + (size * this.bottomCorrection))
            } else {
              ctx.fillText(u, x, y + (size * this.bottomCorrection), w)
            }
          }
        }
      }
      const gaijiFillText = (u, ctx, x, y, size, maxWidth) => {
        let uList = Array.from(u)
        let totalWidth = 0
        let fillList = uList.map(((uc, index) => {
          let g = gaijiCheck(uc)
          let w = (g) ? size : ctx.measureText(uc).width
          totalWidth += w
          return {
            c: uc,
            w: w,
            g: g,
          }
        }))
        let ratio = ((maxWidth === undefined) || (maxWidth >= totalWidth)) ? 1 : (maxWidth / totalWidth)
        let gw = size * ratio
        fillList.forEach(((obj, index) => {
          if (obj.g) {
            ctx.drawImage(obj.g.glyph,x,y-size,gw,size)
            if (debugOut) {console.log(`gaiji:\\u${obj.g.hex} ${x},${y-size},${gw},${size}`)}
            x += gw
          } else {
            if (obj.c !== layoutConst.tagControlStr) {
              if (ratio === 1) {
                ctx.fillText(obj.c, x, y + (size * this.bottomCorrection))
                x += obj.w
              } else {
                let tw = obj.w * ratio
                ctx.fillText(obj.c, x, y + (size * this.bottomCorrection), tw)
                x += tw
              }
            }
          }
        }))
      }
      ctx.restore()
      if (this.loading) return this.offcvs.toDataURL()
      if (debugOut) {console.log(`drawing page${page}`)}

      let pd = this.pageData[page]
      let nombreMode = pd.nombre

      if (pd.picture) {
        let capFontSize = Math.floor(this.letterSize * 0.8)
        let capLineSpace = this.letterSize / 10
        let picNum = pd.picture.picNum & PictureFlags.numberMask
        let picFill = (pd.picture.picNum & PictureFlags.fillPage) !== 0
        let picCover = (pd.picture.picNum & PictureFlags.coverPage) !== 0
        let picInfo = this.loadImage(picNum,page,picCover)
        let contHeight = Math.floor(this.docHeight * nowContentsRatio)
        let capNumLine = 0
        let capWidth = 0
        let caption = pd.picture.picCaption
        let cRatio = this.letterSize / capFontSize
        let rcRatio = capFontSize / this.letterSize
        if (picFill) { nombreMode = NombreMode.off }
        if (caption) {
          if (caption === "") {
            caption = null
          } else {
            ctx.save()
            //ctx.font = `${capFontSize}px ${this.picCapFont}`
            ctx.font = `${this.letterSize}px ${this.picCapFont}`
            ctx.textBaseline = layoutConst.drawTextBaseline
            capWidth = ctx.measureText(caption).width * rcRatio
            capNumLine = (capWidth > this.wpContWidth) ? Math.ceil(capWidth / this.wpContWidth) : 1
            ctx.restore()
          }
        }
        let capHeight = (capFontSize + capLineSpace) * capNumLine
        let picLeft = picFill ? 0 : left
        let picTop = picFill ? 0 : top
        let width = 0
        let height = 0
        if (debugOut) {console.log("picInfo :" + JSON.stringify(picInfo))}
        if (picInfo.img) {
          let pic = picInfo.img
          if (picCover && (picInfo.status !== 1)) {  //カバー仮画像作成
            let img = new Image()
            let cv = document.createElement('canvas')
            let cvSize = Math.floor(this.bufWidth * nowContentsRatio)
            if (debugOut) {console.log(`cvSize : ${cvSize}`)}
            cv.width = cvSize
            cv.height = cvSize
            let ct = cv.getContext('2d')
            ct.fillStyle = "#000000"
            let ctFontFamily = this.letterFont
            let ttBase = 0

            for(let s = 0;s < 2;s += 1) {
              ct.save()
              let nowTitle = (s === 0)
              if (debugOut) {console.log(this.contentsTitle + ',' + this.authorName)}
              let ttl = nowTitle
                  ? this.contentsTitle.length > 0 ? this.contentsTitle.split('\n') : '名称未設定'
                  : this.authorName.length > 0 ? this.authorName.split('\n') : '作者不詳'
              let ctFontSize = 100
              ct.font = `${ctFontSize}px ${ctFontFamily}`
              ct.textBaseline = layoutConst.drawTextBaseline
              let ttw = 0
              ttl.forEach(v => {
                let tw = ct.measureText(v).width
                if (ttw < tw) ttw = tw
              })
              let ttr = Math.floor(cvSize / ttw * 10) / 10
              ctFontSize *= ttr
              let tmpSize = (nowTitle ? 48 : 30) * window.devicePixelRatio
              if (ctFontSize > tmpSize) ctFontSize = tmpSize
              tmpSize = (nowTitle ? 30 : 16) * window.devicePixelRatio
              if (ctFontSize < tmpSize) ctFontSize = tmpSize
              ct.font = `${ctFontSize}px ${ctFontFamily}`
              ct.textBaseline = layoutConst.drawTextBaseline
              let ttCenter = ttl.length <= 1
              let ttLeft = 0
              let ttLineSpace = Math.floor(ctFontSize * 1.5)
              let ttwRatio = 1
              ttBase = ttLineSpace + (nowTitle ? 0 : ttBase)

              if (ttLeft < 0) ttLeft = 0
              ttw = cvSize - ttLeft
              let ttwa = ttl.map(v => {
                let ttlw = ct.measureText(v).width
                if (ttlw > ttw) {
                  let tr = ttw / ttlw
                  if (ttwRatio > tr) ttwRatio = tr
                }
                return ttlw
              })
              ttl.forEach((v, i) => {
                if (ttwRatio === 1) {
                  if (ttCenter) ttLeft = Math.floor((cvSize - ttwa[i]) / 2)
                  // ct.fillText(v, ttLeft, ttBase)
                  gaijiFillText(v,ct,ttLeft,ttBase,ctFontSize)
                } else {
                  let tttw = Math.floor(ttwa[i] * ttwRatio * 10) / 10
                  if (ttCenter) ttLeft = Math.floor((cvSize - tttw) / 2)
                  // ct.fillText(v, ttLeft, ttBase, tttw)
                  gaijiFillText(v,ct,ttLeft,ttBase,ctFontSize,tttw)
                }
                ttBase += ttLineSpace
              })
              if (nowTitle) {
                ct.strokeStyle = "#000000"
                ct.strokeWidth = 2 * window.devicePixelRatio
                ttBase += -ttLineSpace + (10 * window.devicePixelRatio)
                ct.beginPath()
                ct.moveTo(0,ttBase)
                ct.lineTo(cvSize,ttBase)
                ct.stroke()
              }
              ct.restore()
            }
            pic = cv
          }
          width = pic.width
          height = pic.height
          let picRatio = width / height
          let picContentsRatio = (picFill ? 1 : nowContentsRatio)
          if (this.appAspect < picRatio) {  //横幅一杯に
            // width = this.wpContWidth
            width = this.documentAreaWidth * picContentsRatio
            height = width / picRatio
            picTop = (this.documentAreaHeight - height) / 2
            if ((this.documentAreaHeight * picContentsRatio) > (height + capHeight)) picTop -= capHeight / 2
          } else {                          //縦高一杯に
            height = Math.floor(this.documentAreaHeight * picContentsRatio)
            width = height * picRatio
            // picLeft += (this.wpContWidth - width) / 2
            picLeft = (this.documentAreaWidth - width) / 2
          }
          if (isNaN(picLeft) || isNaN(picTop) || isNaN(width) || isNaN(height)) {
            if (debugOut) {console.log(`pic : (${picLeft},${picTop},${width},${height})`)}
          }
          ctx.drawImage(pic,picLeft,picTop,width,height)
        }
        if (caption !== null) {
          ctx.save()
          ctx.font = `${this.letterSize}px ${this.picCapFont}`
          ctx.textBaseline = layoutConst.drawTextBaseline
          ctx.scale(rcRatio,rcRatio)
          if (contHeight > (height + capHeight)) {
            picTop += height
          } else {
            picTop = top + contHeight - capHeight - capFontSize
          }
          ctx.fillStyle = "#000000"
          if (capNumLine === 1) {
            // ctx.fillText(caption,(this.wpContWidth - capWidth) * cRatio,picTop * cRatio)
            gaijiFillText(caption,ctx,(this.wpContWidth - capWidth) * cRatio,picTop * cRatio,this.letterSize)
          } else {
            let arr = Array.from(caption)
            let lfIndex = []
            let lastDelm = -1
            let lw = 0
            arr.forEach((value, index) => {
              let w = ctx.measureText(value).width * rcRatio
              if (lw + w > this.wpContWidth) {
                lfIndex.push(lastDelm === -1 ? index : lastDelm+1)
                lastDelm = -1
                lw = 0
              } else {
                if (value === ' ') {
                  lastDelm = index
                }
                lw += w
              }
            })
            let lastIndex = lfIndex.length - 1
            if ((lastIndex < 0) || (lfIndex[lastIndex] !== arr.length))  lfIndex.push(arr.length)
            lastIndex = 0
            lfIndex.forEach(value => {
              // ctx.fillText(arr.slice(lastIndex,value).join(""),left * cRatio,picTop * cRatio)
              gaijiFillText(arr.slice(lastIndex,value).join(""),ctx,left * cRatio,picTop * cRatio,this.letterSize)
              lastIndex = value
              picTop += capFontSize + capLineSpace
            })
          }
          ctx.restore()
        }
      } else {
        let nowLetterFont = (this.vertically ? this.letterVFont + ", " : "") + this.letterFont
        ctx.font = `${this.letterSize}px ${nowLetterFont}`
        ctx.textBaseline = layoutConst.drawTextBaseline
        ctx.fillStyle = "#000000"
        const wavyLine = (x, y, mx, my, amplitude, waveLen, strokeStyle) => {
          let calcRadian = (x, y, mx, my) => {
            return Math.atan2(my - y, mx - x)
          }
          let calcDistance = (x, y, mx, my) => {
            return Math.hypot(my - y, mx - x)
          }
          if (amplitude === undefined) amplitude = 3
          if (waveLen === undefined) waveLen = 3

          const BEGIN = 0, CTRL = 1, END = 2, X = 0, Y = 1
          let distance = calcDistance(x, y, mx, my)
          let cycle = Math.floor(distance / waveLen)
          let ps = [[x, y], [0, 0], [x, y]]
          ctx.save()
          ctx.strokeStyle = strokeStyle || "#000000"
          ctx.beginPath()
          ctx.moveTo(ps[BEGIN][X], ps[BEGIN][Y])
          let rad = calcRadian(x, y, mx, my)
          if (0 !== rad) {
            ctx.translate(x, y)
            ctx.rotate(rad)
            ctx.translate(-x, -y)
          }
          for (let i = 0; i < cycle; i++) {
            ps[END][X] += waveLen
            ps[CTRL][X] = ps[BEGIN][X] + ((ps[END][X] - ps[BEGIN][X]) * 0.5)
            ps[CTRL][Y] = ps[BEGIN][Y] + ((i % 2 !== 0) ? -amplitude : amplitude)
            ctx.quadraticCurveTo(ps[CTRL][X], ps[CTRL][Y], ps[END][X], ps[END][Y])
            ps[BEGIN][X] = ps[END][X]
            ps[BEGIN][Y] = ps[END][Y]
          }
          ps[END][X] += distance - calcDistance(x, y, ps[END][X], ps[END][Y])
          ps[CTRL][X] = ps[BEGIN][X] + ((ps[END][X] - ps[BEGIN][X]) * 0.5)
          ps[CTRL][Y] = ps[BEGIN][Y] + (((cycle) % 2 !== 0) ? -amplitude : amplitude)
          ctx.quadraticCurveTo(ps[CTRL][X], ps[CTRL][Y], ps[END][X], ps[END][Y])
          ctx.stroke()
          ctx.restore()
        }
        const drawLine = (style, pos, start, end) => {
          if (style === LineStyle.end) return
          let x0, y0, x1, y1
          if (this.vertically) {
            x0 = pos
            y0 = start
            x1 = pos
            y1 = end
          } else {
            x0 = start
            y0 = pos
            x1 = end
            y1 = pos
          }
          ctx.save()
          ctx.lineWidth = Math.floor(baseLineWidth)
          ctx.strokeStyle = "#000000"
          // noinspection FallThroughInSwitchStatementJS
          switch (style) {
            case LineStyle.thick:
              ctx.lineWidth = Math.floor(baseLineWidth * 2)
            case LineStyle.single:
            case LineStyle.double:
              if (this.vertically) {
                x0 -= 1
                x1 -= 1
              }
              ctx.beginPath()
              ctx.moveTo(x0, y0)
              ctx.lineTo(x1, y1)
              ctx.stroke()
              if (style !== LineStyle.double) {break}
              let maggk = (window.devicePixelRatio > 1.5 ? 2 : 3)
              let mag = Math.round(maggk * baseLineWidth)
              if (mag < maggk) {mag = maggk}
              if (this.vertically) {
                x0 += mag
                x1 += mag
              } else {
                y0 += mag
                y1 += mag
              }
              ctx.beginPath()
              ctx.moveTo(x0, y0)
              ctx.lineTo(x1, y1)
              ctx.stroke()
              break
            case LineStyle.dotted:
              ctx.beginPath()
              ctx.setLineDash([2, 2])
              ctx.moveTo(x0, y0)
              ctx.lineTo(x1, y1)
              ctx.stroke()
              break
            case LineStyle.wavy:
              if (this.vertically) {
                x0 += 1
                x1 += 1
              } else {
                y0 += 1.5
                y1 += 1.5
              }
              let m = (this.letterSize > 18) ? (this.letterSize / 18) : 1
              if (window.devicePixelRatio > 1.5) {
                wavyLine(x0, y0, x1, y1, 3 * m, 4 * m)
              } else {
                wavyLine(x0, y0, x1, y1, 5 * m, 8 * m)
              }
              break
          }
          ctx.restore()
        }
        const colorDot = (ctx, x, y, size, color) => {
          ctx.save()
          ctx.fillStyle = color || "#1aff51"
          ctx.beginPath();
          ctx.arc(x, y, size | 0.5, 0, (Math.PI*2), false);
          ctx.fill();
          ctx.restore()
        }
        if (this.vertically) {
          // 文字の縦方向描画基準はalphabetic（文字の下の方）
          let dashStart = -1
          let ellipsisStart = -1
          let ellipsisCount = 0
          let nextPosX = right
          const vertFillText = (ctx, text, x, y, gflg) => {
            ctx.save()
            ctx.font = `${this.letterSize}px ${this.letterFont}`
            ctx.textBaseline = layoutConst.drawTextBaseline
            ctx.translate(x, y)
            ctx.rotate(90 * Math.PI / 180)
            ctx.translate(-x, -y)
            if (gflg) {
              gaijiFillText(text,ctx,x,y,this.letterSize)
            } else {
              ctx.fillText(text, x, y+(this.letterSize * this.bottomCorrection))
            }
            ctx.restore()
          }
          const vertFillTextMaxWidth = (ctx, text, x, y,mw ,gflg) => {
            ctx.save()
            ctx.font = `${this.letterSize}px ${this.letterFont}`
            ctx.textBaseline = layoutConst.drawTextBaseline
            ctx.translate(x, y)
            ctx.rotate(90 * Math.PI / 180)
            ctx.translate(-x, -y)
            if (gflg) {
              gaijiFillText(text,ctx,x,y,this.letterSize,mw)
            } else {
              ctx.fillText(text, x, y+(this.letterSize * this.bottomCorrection), mw)
            }
            ctx.restore()
          }

          pd.index.forEach((v, i) => {
            let lines = undefined
            let decorationDraw = true
            let subjectFlag = false
            if (v < 0) {
              lines = {
                start:0,
                length:0,
                n:v,
                ni:0,
                properties: (v === SpecialLineIndex.lineFeedWp) ? PropFlag.isWpage : 0,
                letters:[],
                picture:null,
                pagenew:false,
                rubys:[],
                nm:null,
                fd:0,
              }
              decorationDraw = false
            } else {
              lines = this.layoutData.contents[v]
              if (lines === undefined) return
              subjectFlag = (lines.properties & PropFlag.subject) !== 0
            }
            let nowSubjectRatio = subjectFlag ? layoutConst.subjectRatio : 1
            let lineLetterSize = this.letterSize * nowSubjectRatio
            let lineLineHeight = this.lineHeight * nowSubjectRatio
            let vertBaselineOffset = (layoutConst.lineSpacing + 0) * nowSubjectRatio
            let letterOffset = (this.lineHeight - 4) * nowSubjectRatio
            let tcurWidth = (this.letterSize * 1.2) * nowSubjectRatio
            let tcurXOffset = (tcurWidth - lineLetterSize) / 2
            let underlineWidth = ((lines.properties & PropFlag.hasLine) === 0) ? 0 : 8
            let rubyOffset = lineLetterSize
            let dotOffset = lineLetterSize
            let letterVOffset = (this.letterSize - 0) * nowSubjectRatio
            let rubyVOffset = this.rubySize * nowSubjectRatio
            // let posX = left + ((i >= numLineOne) ? this.docWidth : 0)
            // let posY = top + ((i % numLineOne) * lineLineHeight)
            if (pd.wpLen && (i === pd.wpLen)) { nextPosX = right }
            let posX = nextPosX - lineLineHeight
            let posY = top + ((lines.properties & PropFlag.isWpage) ? this.docHeight : 0)
            nextPosX = posX

            ctx.font = `${lineLetterSize}px ${nowLetterFont}`
            ctx.textBaseline = layoutConst.drawTextBaseline

            let rubyArea = []
            // ctx.font = this.rubyFontStyle
            let rRatio = this.letterSize / this.rubySize
            ctx.save()
            ctx.scale(1 / rRatio,1 / rRatio)
            lines.rubys.forEach((rv, ri) => {
              let rtype = rv.type
              let hasGaiji = (rtype & WordType.gaiji) !== 0
              let areaStart = rv.point
              let start = (areaStart * letterRatio) + rubyVOffset
              let rarea = 0
              if (rv.poss !== undefined) {    //均等割
                let rarr = Array.from(rv.ruby)
                rarea = rv.area
                // if (rv.next) {
                if (debugOut) {console.log(`ルビ均等割(nextあり):${rv.ruby} Area ${areaStart} - ${rarea}`)}
                let rposX = posX + rubyOffset
                let rposY = posY + start  // + rv.next.mod
                if (hasGaiji) {
                  rarr.forEach((rvl, rvi) => {
                    let py = rv.poss[rvi]
                    if (!isNaN(py)) {
                      py *= letterRatio
                      drawGaiji(rvl,ctx,rposX * rRatio + underlineWidth,(rposY + py) * rRatio,this.letterSize)
                    }
                  })
                } else {
                  let bCorr = (this.letterSize * this.bottomCorrection)
                  rarr.forEach((rvl, rvi) => {
                    let py = rv.poss[rvi]
                    if (!isNaN(py)) {
                      py *= letterRatio
                      ctx.fillText(rvl, rposX * rRatio + underlineWidth, (rposY + py) * rRatio + bCorr)
                    }
                  })
                }
               } else {
                if (rv.widths) {
                  let rarr = Array.from(rv.ruby)
                  let one = (rarr.length <= 1) || ((rarr.length & 1) === 0)       //1文字以下か偶数なら
                  rarea = rv.area
                  if (debugOut) {console.log(`ルビ均等割:${rv.ruby} Area ${areaStart} - ${rarea}`)}
                  let rgap = Math.floor((rv.area - rv.width) / (rarr.length + (one ? 1 : -1)) * 10) / 10
                  let rposX = posX + rubyOffset
                  let rposY = posY + start + (one ? rgap : 0)
                  if (hasGaiji) {
                    rarr.forEach((rvl, rvi) => {
                      drawGaiji(rvl,ctx,rposX * rRatio + underlineWidth,rposY * rRatio,this.letterSize)
                      rposY += (rv.widths[rvi] + rgap) * letterRatio
                    })
                  } else {
                    let bCorr = (this.letterSize * this.bottomCorrection)
                    rarr.forEach((rvl, rvi) => {
                      ctx.fillText(rvl, rposX * rRatio + underlineWidth, rposY * rRatio + bCorr)
                      rposY += (rv.widths[rvi] + rgap) * letterRatio
                    })
                  }
                } else {
                  if ((rtype & WordType.kaomoji) !== 0) {
                    if (!rv.maxTextWidth) {
                      rarea = rv.length * this.rubySize
                      if (debugOut) {  console.log(`ルビベタ打ち:${rv.ruby} Area ${areaStart} - ${rarea}`) }
                      vertFillText(ctx, rv.ruby, (posX + rubyOffset) * rRatio + underlineWidth, (posY + start - rubyVOffset) * rRatio)
                    } else {
                      rarea = rv.maxTextWidth
                      if (debugOut) { console.log(`ルビベタ打ち(縮小):${rv.ruby} Area ${areaStart} - ${rarea}`) }
                      vertFillTextMaxWidth(ctx, rv.ruby, (posX + rubyOffset) * rRatio + underlineWidth, (posY + start - rubyVOffset) * rRatio, rv.maxTextWidth * rRatio)
                    }
                  } else {
                    let rarr = Array.from(rv.ruby)
                    let step = rubyVOffset
                    let tmpRRatio = rRatio
                    if (!rv.maxTextWidth) {
                      rarea = rarr.length * this.rubySize
                      if (debugOut) {  console.log(`ルビベタ打ち:${rv.ruby} Area ${areaStart} - ${rarea}`) }
                    } else {
                      rarea = rv.maxTextWidth
                      if (debugOut) { console.log(`ルビベタ打ち(縮小):${rv.ruby} Area ${areaStart} - ${rarea}`) }
                      step = rarea / rarr.length
                      tmpRRatio = rRatio * step / rubyVOffset
                      if (rRatio !== tmpRRatio) {
                        ctx.restore()
                        ctx.save()
                        ctx.scale(1 / tmpRRatio, 1 / tmpRRatio)
                      }
                    }
                    // if (rv.next) {
                    let rposX = posX + rubyOffset
                    let rposY = posY + start
                    if (hasGaiji) {
                      rarr.forEach((rvl, rvi) => {
                        drawGaiji(rvl,ctx,rposX * tmpRRatio + underlineWidth,(rposY + (step * rvi)) * tmpRRatio,this.letterSize)
                      })
                    } else {
                      let bCorr = (this.letterSize * this.bottomCorrection)
                      rarr.forEach((rvl, rvi) => {
                        ctx.fillText(rvl, rposX * tmpRRatio + underlineWidth, (rposY + (step * rvi)) * tmpRRatio + bCorr)
                      })
                    }
                    if (rRatio !== tmpRRatio) {
                      ctx.restore()
                      ctx.save()
                      ctx.scale(1 / rRatio, 1 / rRatio)
                    }
                  }
                }
              }
              rubyArea.push({start: areaStart, end: areaStart + rarea})
            })
            ctx.restore()
            let nowLine = LineStyle.end
            let nowStrike = LineStyle.end
            let lineArea = []
            let strikeArea = []
            // if (nowLine !== LineStyle.end) {
            //   lineArea.push({line:nowLine,start:0,end:-1})
            // }
            let lettersLastIndex = lines.letters.length - 1
            lines.letters.forEach((lv, li, larr) => {
              let replaceGraphicDraw = false
              if (lv.type & WordTypeMask.linedashMask) {
                if (dashStart === -1) dashStart = lv.point + 1
              } else {
                if (lv.type & WordTypeMask.ellipsisMask) {
                  if (ellipsisStart === -1) ellipsisStart = lv.point + 1
                  ellipsisCount += 1
                }
              }
              if ((dashStart !== -1) && ((li === lettersLastIndex) || ((li < lettersLastIndex) && ((larr[li + 1].type & WordTypeMask.linedashMask) === 0)))) {
                let dex = posX + (lineLetterSize * 0.5)
                let dey0 = posY + (dashStart * letterRatio)
                let dey1 = posY + ((lv.point + lv.width - 1) * letterRatio)
                ctx.save()
                ctx.strokeStyle = "#000000"
                ctx.lineWidth = lineLetterSize * letterRatio * this.graphRatio * 0.04
                ctx.beginPath()
                ctx.moveTo(dex, dey0)
                ctx.lineTo(dex, dey1)
                ctx.stroke()
                ctx.restore()
                dashStart = -1
                replaceGraphicDraw = true
              } else {
                if ((ellipsisStart !== -1) && ((li === lettersLastIndex) || ((li < lettersLastIndex) && ((larr[li + 1].type & WordTypeMask.ellipsisMask) === 0) || (lv.letter !== larr[li + 1].letter)))) {
                  // let lowerLine = lv.letter !== "⋯"          //縦書き時は中央
                  let numOfDot = (lv.letter === "\u2025" ? 2 : 3) * ellipsisCount
                  let dotRadius = lineLetterSize * letterRatio * this.graphRatio * 0.04
                  let ellipsWidth = ((lv.point + lv.width - 1 - ellipsisStart) * letterRatio)
                  let ellipsX = posX + (lineLetterSize * 0.5)   //縦書き時は全て中央
                  let step = Math.floor(ellipsWidth / numOfDot * 10) / 10
                  let start = posY + (ellipsisStart * letterRatio) + (step * 0.5)
                  ctx.save()
                  ctx.beginPath()
                  for(let i = 0; i < numOfDot ; i++) {
                    let c = Math.floor((start + (step * i)) * 10) / 10
                    ctx.arc(ellipsX, c, dotRadius,0,2 * Math.PI)
                  }
                  ctx.fillStyle = "#000000"
                  ctx.fill()
                  ctx.restore()
                  ellipsisStart = -1
                  ellipsisCount = 0
                  replaceGraphicDraw = true
                }
              }
              if (!replaceGraphicDraw && (dashStart === -1) && (ellipsisStart === -1)) {
                // ctx.font = `${lineLetterSize}px ${nowLetterFont}`
                let tateHan = (lv.type & WordTypeMask.tateHanMask)
                if ((tateHan === WordType.to_sw) || (lv.type & WordType.kaomoji)) {
                  vertFillText(ctx,lv.letter,posX + vertBaselineOffset,posY + (lv.point * letterRatio))
                } else {
                  let bCorr = (this.letterSize * this.bottomCorrection)
                  if (tateHan === WordType.tc_ur) {
                    if (debugOut) {console.log(`tc_ur:${lv.letter}`)}
                    let tposX = posX - tcurXOffset
                    let tmpWidth = ctx.measureText(lv.letter).width
                    if (tmpWidth > tcurWidth) {
                      ctx.fillText(lv.letter, tposX, posY + (lv.point * letterRatio) + letterVOffset + bCorr, tcurWidth)
                    } else {
                      ctx.fillText(lv.letter, tposX + (tcurWidth - tmpWidth) / 2, posY + (lv.point * letterRatio) + letterVOffset + bCorr)
                    }
                  } else {
                    if (lv.type & WordType.gaiji) {
                      gaijiFillText(lv.letter,ctx,posX,posY + (lv.point * letterRatio) + letterVOffset,lineLetterSize)
                    } else {
                      if (lv.letter !== layoutConst.tagControlStr) {
                        ctx.fillText(lv.letter, posX, posY + (lv.point * letterRatio) + letterVOffset + bCorr)
                      }
                    }
                  }
                }
              }
              // if (debugOut) {console.log(`${lv.letter} (${posX + (lv.point * letterRatio)},${posY + letterOffset})`)}
              if (lv.dot !== "") {
                // if (debugOut) {
                //   rubyArea.forEach((value, index) => {
                //     console.log(`rubyArea[${index}]:${value.start} - ${value.end}`)
                //   })
                // }
/*
               let dw = ctx.measureText(lv.dot).width * 0.5 / letterRatio
                let dxChk = (lv.point) + ((lv.width - dw) / 2)
                if (debugOut) { console.log(`dot '${lv.letter}' Area ${dxChk} - ${dxChk + dw}`) }
                let dx = posX + (dxChk * letterRatio)
                let dy = posY + letterOffset - dotOffsetDelta - (rubyArea.some((rav) => {
                  return ((dxChk < rav.end) && (rav.start < (dxChk + dw)))
                }) ? (this.rubySize * nowSubjectRatio) : 0)

                let dw = ctx.measureText(lv.dot).width * 0.5 / letterRatio
                let dyChk = (lv.point) + ((lineLetterSize - dw) / 2)
                let dy = posY + (dyChk * letterRatio) + letterVOffset
                if (debugOut) { console.log(`dot '${lv.letter}' Area ${dyChk} - ${dyChk + dw}`) }
                let dx = posX + dotOffset + (rubyArea.some((rav) => {
                  return ((dyChk < rav.end) && (rav.start < (dyChk + dw)))
                }) ? (this.rubySize * nowSubjectRatio) : 0)

 */
                // ctx.font = `${lineLetterSize * 0.5}px ${nowLetterFont}`
                let dRatio = 2
                ctx.save()
                ctx.scale(0.5,0.5)
                // let dw = ctx.measureText(lv.dot).width * 0.5// / letterRatio
                // let dy = posY + (lv.point * letterRatio) + letterVOffset
                // if (debugOut) { console.log(`dot '${lv.letter}' Area ${lv.point} - ${lv.point + dw}`) }
                // let dx = posX + dotOffset + (rubyArea.some((rav) => {
                //   return ((lv.point < rav.end) && (rav.start < (lv.point + dw)))
                // }) ? (this.rubySize * nowSubjectRatio) : 0)
                let dw = layoutConst.tentativeSize * 0.5
                let dyChk = lv.point + layoutConst.tentativeSize * 0.25
                let dy = posY + (dyChk * letterRatio) + (letterVOffset * 0.5)
                if (debugOut) { console.log(`dot '${lv.letter}' Area ${dyChk} - ${dyChk + dw}`) }
                let dx = posX + dotOffset + (rubyArea.some((rav) => {
                  return ((dyChk < rav.end) && (rav.start < (dyChk + dw)))
                }) ? (this.rubySize * nowSubjectRatio) : 0)

                ctx.fillText(lv.dot, dx * dRatio + underlineWidth, dy * dRatio + (this.letterSize * this.bottomCorrection))
                ctx.restore()
              }
              if (nowLine !== lv.line) {
                if (nowLine !== LineStyle.end) {
                  let lal = lineArea.length - 1
                  if (lal >= 0) {
                    let llv = larr[li - 1]
                    lineArea[lal].end = llv.point + llv.width
                  }
                }
                nowLine = lv.line
                if (lv.line !== LineStyle.end) lineArea.push({line: nowLine, start: lv.point, end: -1})
              }
              if (nowStrike !== lv.strike) {
                if (nowStrike !== LineStyle.end) {
                  let lal = strikeArea.length - 1
                  if (lal >= 0) {
                    let llv = larr[li - 1]
                    strikeArea[lal].end = llv.point + llv.width
                  }
                }
                nowStrike = lv.strike
                if (lv.strike !== LineStyle.end) strikeArea.push({strike: nowStrike, start: lv.point, end: -1})
              }
            })
            if (decorationDraw) {
              if (nowLine !== LineStyle.end) {
                let lal = lineArea.length - 1
                if (lal >= 0) {
                  let llv = lines.letters[lines.letters.length - 1]
                  if (llv) lineArea[lal].end = llv.point + llv.width
                }
              }
              if (nowStrike !== LineStyle.end) {
                let lal = strikeArea.length - 1
                if (lal >= 0) {
                  let llv = lines.letters[lines.letters.length - 1]
                  if (llv) strikeArea[lal].end = llv.point + llv.width
                }
              }
              if (lineArea.length > 0) {
                let lapos = posX + lineLineHeight - lineLetterSize
                lineArea.forEach((lav, lai) => {
                  if (lav.end < 0) return
                  drawLine(lav.line, lapos, posY + (lav.start * letterRatio), posY + (lav.end * letterRatio))
                })
              }
              if (strikeArea.length > 0) {
                let lapos = posX + (letterOffset * 0.8) - lineLetterSize
                console.log(`letterOffset:${letterOffset} posY:${posX}`)
                strikeArea.forEach((lav, lai) => {
                  if (lav.end < 0) return
                  drawLine(lav.strike, lapos, posY + (lav.start * letterRatio), posY + (lav.end * letterRatio))
                })
              }
            }
          })
        } else {
          // 文字の縦方向描画基準はalphabetic（文字の下の方）
          let posXOffset = 0
          let dashStart = -1
          let ellipsisStart = -1
          let ellipsisCount = 0
          let nextPosY = top

          pd.index.forEach((v, i) => {
            let lines = undefined
            let decorationDraw = true
            let subjectFlag = false
            if (v < 0) {
              lines = {
                start:0,
                length:0,
                n:v,
                ni:0,
                properties: (v === SpecialLineIndex.lineFeedWp) ? PropFlag.isWpage : 0,
                letters:[],
                picture:null,
                pagenew:false,
                rubys:[],
                nm:null,
                fd:0,
              }
              decorationDraw = false
            } else {
              lines = this.layoutData.contents[v]
              if (lines === undefined) return
              subjectFlag = (lines.properties & PropFlag.subject) !== 0
            }
            let nowSubjectRatio = subjectFlag ? layoutConst.subjectRatio : 1
            let lineLetterSize = this.letterSize * nowSubjectRatio
            let lineLineHeight = this.lineHeight * nowSubjectRatio
            let letterOffset = (this.lineHeight - 4) * nowSubjectRatio
            let rubyOffset = letterOffset - lineLetterSize
            let dotOffsetDelta = lineLetterSize
            // let posX = left + ((i >= numLineOne) ? this.docWidth : 0)
            // let posY = top + ((i % numLineOne) * lineLineHeight)
            if (pd.wpLen && (i === pd.wpLen)) { nextPosY = top }
            let posX = left + ((lines.properties & PropFlag.isWpage) ? this.docWidth : 0)
            let posY = nextPosY
            nextPosY = posY + lineLineHeight
            // if (nextPosY > yLimit) {
            //   if (this.wpages) { posXOffset = this.docWidth }
            //   nextPosY = top
            // }

            ctx.font = `${lineLetterSize}px ${nowLetterFont}`
            ctx.textBaseline = layoutConst.drawTextBaseline

            let rubyArea = []
            // ctx.font = this.rubyFontStyle
            let rRatio = this.letterSize / this.rubySize
            let bCorr = (this.letterSize * this.bottomCorrection)
            ctx.save()
            ctx.scale(1 / rRatio,1 / rRatio)
            lines.rubys.forEach((rv, ri) => {
              let areaStart = rv.point
              let start = (areaStart * letterRatio)
              let rarea = 0
              if (rv.poss !== undefined) {    //均等割
                let rarr = Array.from(rv.ruby)
                rarea = rv.area
                if (debugOut) {console.log(`ルビ均等割(nextあり):${rv.ruby} Area ${areaStart} - ${rarea}`)}
                let rposX = posX + start  // + rv.next.mod
                let rposY = posY + rubyOffset

                if (rv.type & WordType.gaiji) {
                  rarr.forEach((rvl, rvi) => {
                    let px = rv.poss[rvi]
                    if (!isNaN(px)) {
                      px *= letterRatio
                      drawGaiji(rvl,ctx,(rposX + px) * rRatio,rposY * rRatio,this.letterSize)
                    }
                  })
                } else {
                  rarr.forEach((rvl, rvi) => {
                    let px = rv.poss[rvi]
                    if (!isNaN(px) && (rvl !== layoutConst.tagControlStr)) {
                      px *= letterRatio
                      ctx.fillText(rvl, (rposX + px) * rRatio, rposY * rRatio + bCorr)
                    }
                  })
                }
              } else {
                if (rv.widths) {
                  let rarr = Array.from(rv.ruby)
                  let one = (rarr.length <= 1) || ((rarr.length & 1) === 0)       //1文字以下か偶数なら
                  rarea = rv.area
                  if (debugOut) {console.log(`ルビ均等割:${rv.ruby} Area ${areaStart} - ${rarea}`)}
                  let rgap = Math.floor((rv.area - rv.width) / (rarr.length + (one ? 1 : -1)) * 10) / 10
                  let rposX = posX + start + (one ? rgap : 0)
                  let rposY = posY + rubyOffset
                  if (rv.type & WordType.gaiji) {
                    rarr.forEach((rvl, rvi) => {
                      drawGaiji(rvl,ctx,rposX * rRatio,rposY * rRatio,this.letterSize)
                      rposX += (rv.widths[rvi] + rgap) * letterRatio
                    })
                  } else {
                    rarr.forEach((rvl, rvi) => {
                      if (rvl !== layoutConst.tagControlStr) {
                        ctx.fillText(rvl, rposX * rRatio, rposY * rRatio + bCorr)
                      }
                      rposX += (rv.widths[rvi] + rgap) * letterRatio
                    })
                  }
                } else {
                  if (!rv.maxTextWidth) {
                    rarea = rv.width
                    if (debugOut) {console.log(`ルビベタ打ち:${rv.ruby} Area ${areaStart} - ${rarea}`)}
                    if (rv.type & WordType.gaiji) {
                      gaijiFillText(rv.ruby,ctx,(posX + start) * rRatio,(posY + rubyOffset) * rRatio,this.letterSize)
                    } else {
                      if (rv.ruby !== layoutConst.tagControlStr) {
                        ctx.fillText(rv.ruby, (posX + start) * rRatio, (posY + rubyOffset) * rRatio + bCorr)
                      }
                    }
                  } else {
                    rarea = rv.maxTextWidth
                    if (debugOut) {console.log(`ルビベタ打ち(縮小):${rv.ruby} Area ${areaStart} - ${rarea}`)}
                    if (rv.type & WordType.gaiji) {
                      gaijiFillText(rv.ruby,ctx,(posX + start) * rRatio,(posY + rubyOffset) * rRatio,this.letterSize,rv.maxTextWidth * rRatio)
                    } else {
                      if (rv.ruby !== layoutConst.tagControlStr) {
                        ctx.fillText(rv.ruby, (posX + start) * rRatio, (posY + rubyOffset) * rRatio + bCorr, rv.maxTextWidth * rRatio)
                      }
                    }
                  }
                }
              }
              rubyArea.push({start: areaStart, end: areaStart + rarea})
            })
            ctx.restore()
            let nowLine = LineStyle.end
            let nowStrike = LineStyle.end
            let lineArea = []
            let strikeArea = []
            // if (nowLine !== LineStyle.end) {
            //   lineArea.push({line:nowLine,start:0,end:-1})
            // }
            let lettersLastIndex = lines.letters.length - 1
            lines.letters.forEach((lv, li, larr) => {
              let replaceGraphicDraw = false
              if (lv.type & WordTypeMask.linedashMask) {
                if (dashStart === -1) dashStart = lv.point + 1
              } else {
                if (lv.type & WordTypeMask.ellipsisMask) {
                  if (ellipsisStart === -1) ellipsisStart = lv.point + 1
                  ellipsisCount += 1
                }
              }
              if ((dashStart !== -1) && ((li === lettersLastIndex) || ((li < lettersLastIndex) && ((larr[li + 1].type & WordTypeMask.linedashMask) === 0)))) {
                let dex0 = posX + (dashStart * letterRatio)
                let dex1 = posX + ((lv.point + lv.width - 1) * letterRatio)
                let dey = posY + letterOffset - (lineLetterSize * 0.4)
                ctx.save()
                ctx.strokeStyle = "#000000"
                ctx.lineWidth = lineLetterSize * letterRatio * this.graphRatio * 0.04
                ctx.beginPath()
                ctx.moveTo(dex0, dey)
                ctx.lineTo(dex1, dey)
                ctx.stroke()
                ctx.restore()
                dashStart = -1
                replaceGraphicDraw = true
              } else {
                if ((ellipsisStart !== -1) && ((li === lettersLastIndex) || ((li < lettersLastIndex) && ((larr[li + 1].type & WordTypeMask.ellipsisMask) === 0) || (lv.letter !== larr[li + 1].letter)))) {
                  let lowerLine = lv.letter !== "⋯"
                  let numOfDot = (lowerLine ? 2 : 3) * ellipsisCount
                  let dotRadius = lineLetterSize * letterRatio * this.graphRatio * 0.04
                  let ellipsWidth = ((lv.point + lv.width - 1 - ellipsisStart) * letterRatio)
                  let ellipsY = posY + letterOffset - (lineLetterSize * (lowerLine ? 0.1 : 0.4))
                  let step = Math.floor(ellipsWidth / numOfDot * 10) / 10
                  let start = posX + (ellipsisStart * letterRatio) + (step * 0.5)
                  ctx.save()
                  ctx.beginPath()
                  for(let i = 0; i < numOfDot ; i++) {
                    let c = Math.floor((start + (step * i)) * 10) / 10
                    ctx.arc(c,ellipsY,dotRadius,0,2 * Math.PI)
                  }
                  ctx.fillStyle = "#000000"
                  ctx.fill()
                  ctx.restore()
                  ellipsisStart = -1
                  ellipsisCount = 0
                  replaceGraphicDraw = true
                }
              }
              if (!replaceGraphicDraw && (dashStart === -1) && (ellipsisStart === -1)) {
                // ctx.font = `${lineLetterSize}px ${nowLetterFont}`
                if (lv.type & WordType.gaiji) {
                  drawGaiji(lv.letter,ctx,posX + (lv.point * letterRatio),posY + letterOffset,lineLetterSize)
                } else {
                  if (lv.letter !== layoutConst.tagControlStr) {
                    ctx.fillText(lv.letter, posX + (lv.point * letterRatio), posY + letterOffset + bCorr)
                  }
                }
              }
              // if (debugOut) {console.log(`${lv.letter} (${posX + (lv.point * letterRatio)},${posY + letterOffset})`)}
              if (lv.dot !== "") {
                // if (debugOut) {
                //   rubyArea.forEach((value, index) => {
                //     console.log(`rubyArea[${index}]:${value.start} - ${value.end}`)
                //   })
                // }

                // ctx.font = `${lineLetterSize * 0.5}px ${nowLetterFont}`
                let dRatio = 2
                ctx.save()
                ctx.scale(0.5,0.5)
                let dw = ctx.measureText(lv.dot).width * 0.5 / letterRatio
                let dxChk = (lv.point) + ((lv.width - dw) / 2)
                if (debugOut) { console.log(`dot '${lv.letter}' Area ${dxChk} - ${dxChk + dw}`) }
                let dx = posX + (dxChk * letterRatio)
                let dy = posY + letterOffset - dotOffsetDelta - (rubyArea.some((rav) => {
                  return ((dxChk < rav.end) && (rav.start < (dxChk + dw)))
                }) ? (this.rubySize * nowSubjectRatio) : 0)
                ctx.fillText(lv.dot, dx * dRatio, dy * dRatio + bCorr)
                ctx.restore()
              }
              if (nowLine !== lv.line) {
                if (nowLine !== LineStyle.end) {
                  let lal = lineArea.length - 1
                  if (lal >= 0) {
                    let llv = larr[li - 1]
                    lineArea[lal].end = llv.point + llv.width
                  }
                }
                nowLine = lv.line
                if (lv.line !== LineStyle.end) lineArea.push({line: nowLine, start: lv.point, end: -1})
              }
              if (nowStrike !== lv.strike) {
                if (nowStrike !== LineStyle.end) {
                  let lal = strikeArea.length - 1
                  if (lal >= 0) {
                    let llv = larr[li - 1]
                    strikeArea[lal].end = llv.point + llv.width
                  }
                }
                nowStrike = lv.strike
                if (lv.strike !== LineStyle.end) strikeArea.push({strike: nowStrike, start: lv.point, end: -1})
              }
            })
            if (decorationDraw) {
              if (nowLine !== LineStyle.end) {
                let lal = lineArea.length - 1
                if (lal >= 0) {
                  let llv = lines.letters[lines.letters.length - 1]
                  if (llv) lineArea[lal].end = llv.point + llv.width
                }
              }
              if (nowStrike !== LineStyle.end) {
                let lal = strikeArea.length - 1
                if (lal >= 0) {
                  let llv = lines.letters[lines.letters.length - 1]
                  if (llv) strikeArea[lal].end = llv.point + llv.width
                }
              }
              if (lineArea.length > 0) {
                let lapos = posY + lineLineHeight
                lineArea.forEach((lav, lai) => {
                  if (lav.end < 0) return
                  drawLine(lav.line, lapos, posX + (lav.start * letterRatio), posX + (lav.end * letterRatio))
                })
              }
              if (strikeArea.length > 0) {
                let lapos = posY + (letterOffset * 0.8)
                console.log(`letterOffset:${letterOffset} posY:${posY}`)
                strikeArea.forEach((lav, lai) => {
                  if (lav.end < 0) return
                  drawLine(lav.strike, lapos, posX + (lav.start * letterRatio), posX + (lav.end * letterRatio))
                })
              }
            }
          })
        }
      }
      if (nombreMode !== NombreMode.off) {
        ctx.save()
        let nRatio = this.letterSize / 12
        let rnRatio = 1 / nRatio
        ctx.font = `${this.letterSize}px '${this.$root.ffamNombre}'`
        ctx.textBaseline = layoutConst.drawTextBaseline
        ctx.scale(rnRatio, rnRatio)
        let ptext = (this.pageStart > 1)
          ? `Page ${page + this.pageStart}(${page + 1}/${this.numOfPages})`
          : `Page ${page + this.pageStart}/${this.numOfPages}`
        let metrix = ctx.measureText(ptext).width * rnRatio
        ctx.fillText(
          ptext,
          (this.documentAreaWidth - metrix) / 2 * nRatio,
          (this.documentAreaHeight - 32) * nRatio
        )
        ctx.restore()
        // switch (page) {
        //   case 0:
        //     this.pageImage0 = this.offcvs.toDataURL();
        //     break;
        //   case 1:
        //     this.pageImage1 = this.offcvs.toDataURL();
        //     break;
        //   case 2:
        //     this.pageImage2 = this.offcvs.toDataURL();
        //     break;
        // }
      }
      return this.offcvs.toDataURL();
    },
    flip(dir) {
      this.slideDir = "slide" + dir;
       this.dispOne = this.writeOne;
    },
    unitMulti(vv, t) {
      let splited = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i.exec(vv);
      if (splited == null) return "";
      return `${parseFloat(splited[2], 10) * t}${splited[3]}`;
    },
    clickAction(e) {
      window.getSelection().removeAllRanges()
      if (debugOut) {console.log(`${e.offsetX},${e.offsetY}`)}
      if (!this.uivis) {
        if (this.moving) {
          this.moving = false;
          this.moveTry = false;
          return;
        }
        if (this.moveTry) {
          this.moveTry = false;
          return;
        }
      }
      this.$emit("click",e);
    },
    dragAction() {
      this.$emit("advance", 1);
    },
    pstart(e) {
      if (this.moveAnimating) return false
      if (debugOut) {console.log(e)}
      this.mbtndown = true
      if (this.loading) return
      if (this.uivis) return;
      // if (this.moveAnimating) return
      if (debugOut) {console.log('pstart')}
      this.meStart(e.pageX,e.pageY,e.timeStamp);
    },
    emptySelection() {
      if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {  // IE?
        document.selection.empty();
      }
    },
    tstart(e) {
      if (this.moveAnimating) return false
      if (debugOut) {console.log(e)}
      if (this.loading) return
      if (this.uivis) return
      // if (this.moveAnimating) return;
      if (debugOut) {console.log('tstart')}
      let touch = e.touches[0]
      this.moveTID = touch.identifier
      this.meStart(touch.clientX,touch.clientY,e.timeStamp)
    },
    meStart(x,y,t) {
      this.$store.commit('setNotResigingDoc',true)
      this.emptySelection()
      this.moveStartX = x;
      this.moveStartY = y;
      this.moveStartTime = t;
      this.moving = false;
      this.moveTry = false;
      this.moveEl = document.getElementById(this.dispOne ? 'page1' : 'page2');
    },
    pmove(e) {
      this.emptySelection()
      if (this.moveAnimating || !this.moveEl) return false;
      if (e.buttons == 0) {
        if (this.mbtndown) {
          this.mbtndown = false;
          if (this.moveEl) this.pend(e);
        }
        return;
      }
      if (this.uivis) return
      if (e.movementX == 0) return

      let deltaX = e.pageX - this.moveStartX
       switch (this.meMove(e,deltaX)) {
        case 0:
          break
        case 1:
          if (debugOut) {
            console.log('pmove')
            console.log(e)
          }
          break
        case -1:
          break
      }
    },
    tmove(e) {
      this.emptySelection()
      e.preventDefault();
      if (this.moveAnimating || !this.moveEl) return false;
      if (this.uivis) return;
      let len = e.changedTouches.length;
      let touch = undefined;
      for (let i = 0; i < len; i++) {
        if (e.changedTouches[i].identifier == this.moveTID) {
          touch = e.changedTouches[i];
          break;
        }
      }
      if (touch == undefined) return

      let deltaX = touch.clientX - this.moveStartX
      if (deltaX == 0) return
      switch (this.meMove(e,deltaX)) {
        case 0:
          break
        case 1:
          if (debugOut) {
            console.log('tmove')
            console.log(e)
          }
          break
        case -1:
          break
      }
    },
    meMove(e,deltaX) {
      this.emptySelection()
      if (debugOut) {console.log(`delta H:${deltaX} (left:${parseInt(this.moveEl.style.left)})`)}
      let toLeft = deltaX > 0;
      let nowPage = this.nowPageIndex + 1;
      this.moveTry = true;
      if ((nowPage <= 1) && (toLeft !== this.pageFeedRight)) return 0;
      if ((nowPage >= this.numOfPages) && (toLeft === this.pageFeedRight)) {
        this.$emit("showLastpage")
        return -1;
      }
      if (Math.abs(deltaX) > (this.moveEl.clientWidth * 0.35)) {
        e.preventDefault();
        this.meEnd(e,true);
        return 1;
      }
      this.moveEl.style.left = deltaX + 'px';
      this.toLeft = toLeft;
      let newLeft = deltaX + (this.toLeft ? -this.moveEl.clientWidth : this.moveEl.clientWidth);
      this.moving = true;
      this.page0El.style.left = newLeft + 'px';
      return 1;
    },
    tcancel(e) {
      e.preventDefault()
      if (debugOut) {console.log('pcancel')}
      if (this.moveAnimating) return
      this.meEnd()
    },
    pend(e) {
      if (this.moveAnimating || !this.moveEl) return false
      if (debugOut) {console.log(`pend (${this.mbtndown})>`)}
      if (this.uivis) return
      if (parseInt(this.moveEl.style.left) == 0) return
      e.preventDefault()
      this.meEnd(e)
    },
    tend(e) {
      if (this.moveAnimating || !this.moveEl) return false;
      if (this.uivis) return;
      let len = e.changedTouches.length;
      let touch = undefined;
      for (let i = 0; i < len; i++) {
        if (e.changedTouches[i].identifier == this.moveTID) {
          touch = e.changedTouches[i];
          break;
        }
      }
      if (touch == undefined) return
      if (debugOut) {console.log('tend')}
       this.meEnd(e)
    },
    meEnd(e,forceChange) {
      if (debugOut) {console.log(`page left : ${this.moveEl.style.left}`)}
      this.emptySelection()
      if (parseInt(this.moveEl.style.left) != 0) {
        this.moveAnimating = true;
        this.moveEndAnim(e,0.25,forceChange);
      }
    },
    moveEndAnim(e,durSec,forceChange) {
      if (durSec == undefined) durSec = 1
      let flickCheck = e.timeStamp - this.moveStartTime
      if (debugOut) {console.log(`moveEndAnim (flick? : ${flickCheck / 1000})`)}
      let limit = this.moveEl.clientWidth * ((flickCheck > (0.2 * 1000)) ? 0.5 : 0.1)
      let start = parseInt(this.moveEl.style.left)
      let start0 = parseInt(this.page0El.style.left)
      let distance = Math.abs(start)
      let change = false
      let finishPage = this.pageImageIndex[this.toLeft == this.pageFeedRight ? 2 : 0]
      if (forceChange || (distance > limit)) {
        change = true
        distance = (this.moveEl.clientWidth - distance) * (start < 0 ? -1 : 1)
      } else {
        distance = -start
        finishPage = -1
      }
      if (distance == 0) return;

      let duration = durSec * 1000 * Math.abs(distance) / this.moveEl.clientWidth;
      let startTime = null;
      let self = this;
      let move = function(timeStamp) {
        if (!startTime) startTime = timeStamp;
        let ratio = Math.min(1, (timeStamp - startTime) / duration);
        self.moveEl.style.left = `${start + (distance * ratio)}px`;
        self.page0El.style.left = `${start0 + (distance * ratio)}px`;
        if(ratio < 1) {
          window.requestAnimationFrame(move);
        } else {
          if (finishPage != -1) self.pageUpdate(finishPage);
          self.moveEl.style.left = '0px';
          self.moveFinish();
        }
      };
      window.requestAnimationFrame(move);
    },
    moveFinish() {
      this.moveAnimating = false;
      this.moving = false;
      this.moveEl = null;
    },
    beforeEnterAction(el) {
      el.style.left = this.slideDir == "slideleft" ? this.documentAreaWidth : -this.documentAreaWidth
      el.style.opacity = 1
      if (debugOut) {
        console.log(
            `before-enter:(${el.style.left},${el.style.top})[${el.style.opacity}]`
        )
      }
    },
    enterAction(el) {
      if (debugOut) {console.log("enter")}
      // done();
    },
    afterEnterAction(el) {
      if (debugOut) {console.log("after-enter")}
    },
    enterCancelledAction(el) {
      if (debugOut) {console.log("enter-cancel")}
    },
    beforeLeaveAction(el) {
      if (debugOut) {console.log("before-leave")}
    },
    leaveAction(el) {
      if (debugOut) {console.log("leave")}
      // done();
    },
    afterLeaveAction(el) {
      if (debugOut) {console.log("after-leave")}
      // this.addGestureListeners(el);
    },
    leaveCancelledAction(el) {
      if (debugOut) {console.log("leave-cancelled")}
    }
  }
};
</script>

<style lang="scss" scoped>
.bookpageImage {
  position: absolute;
  z-index: -3;
}
.viewPort {
  position: fixed;
  z-index: -3;
  overflow: hidden;
}
.imageFitFill {
  object-fit: fill;
}
.imageFitNone {
  object-fit: none;
}

.hideElement {
  display: none;
}
.showElement {
  display: block;
}

.slideleft-enter {
  will-change: translate;
  opacity: 1;

    transform: translateX(100vw);
}
.slideleft-leave {
  will-change: translate;
  opacity: 1;
}
.slideleft-enter-active {
  opacity: 1;
  transition: transform 0.25s;
}
.slideleft-leave-active {
  opacity: 1;
  transition: transform 0.25s;
  transform: translateX(-100vw);
}
.slideleft-enter-to {
}
.slideleft-leave-to {
  opacity: 1;
}

.slideright-enter {
    will-change: translate;
    opacity: 1;

    transform: translateX(-100vw);
}
.slideright-leave {
    will-change: translate;
    opacity: 1;
}
.slideright-enter-active {
    opacity: 1;
    transition: transform 0.25s;
}
.slideright-leave-active {
    opacity: 1;
    transition: transform 0.25s;
    transform: translateX(100vw);
}
.slideright-enter-to {
}
slideright-leave-to {
    opacity: 1;
}

@media print {
  body {
    display: none !important;
  }
}

.loader,
.loader:before,
.loader:after {
    border-radius: 50%;
}
.loader {
    color: #cde9b5;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: absolute;
    width: 10em;
    height: 10em;
    left: calc(50% - 5em);
    top: calc(40% - 5em);
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}
.loader:before,
.loader:after {
    position: absolute;
    content: '';
}
.loader:before {
    width: 5.2em;
    height: 10.2em;
    background: #ffffff;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
}
.loader:after {
    width: 5.2em;
    height: 10.2em;
    background: #ffffff;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes load2 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.loader_message {
    color: rgb(24, 42, 75);
    font-size: 200%;
    width: 100vw;
    display: block;
    position: fixed;
    left: 50%;
    top: 15em;
    height: 4rem;
    transform: translateX(-50vw);
}

</style>
